import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex)`
  width: 100%;
  flex-direction: column;
`

export const Content = styled(Flex)`
  width: 100%;
  flex-direction: column;
`

export const Block = styled(Flex).withConfig({
  shouldForwardProp,
})`
  background-color: ${themeGet('colors.white')};
`

export const HorizontalDelimiterHolder = styled(Flex).attrs({
  display: ['none', 'none', 'flex'],
})`
  background-color: ${themeGet('colors.white')};
  z-index: 1;
`
